function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3522",
  "data-name": "Path 3522",
  d: "M13.313-67.125,21.188-136.5h76.5v22.594H43.406L40.031-84.562a42.955,42.955,0,0,1,20.531-5.156q19.5,0,30.563,12.094t11.063,33.844a49.489,49.489,0,0,1-5.578,23.672A39.371,39.371,0,0,1,80.625-3.891Q70.219,1.875,56.063,1.875A52.989,52.989,0,0,1,33.094-3.141,40.741,40.741,0,0,1,16.359-17.25,38.454,38.454,0,0,1,9.844-37.969H36.656Q37.5-29.437,42.609-24.7t13.359,4.734q9.188,0,14.156-6.609t4.969-18.7q0-11.625-5.719-17.812T53.156-69.281q-9.656,0-15.656,5.063l-2.625,2.438Z",
  transform: "translate(-9.844 136.5)",
  fill: "#f37320",
  opacity: 0.1
});

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.344,
    height: 138.375,
    viewBox: "0 0 92.344 138.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.9efbb64ae5e67c974de3b71ff1ffc9c0.svg";
export { ForwardRef as ReactComponent };